<template>
  <v-row>
    <v-col cols="12" class="mt-10">
      <v-col cols="12" md="12" class="py-0 d-flex">
        <v-text-field
          dark
          hide-details
          color="yellow"
          label="Pesquisar"
          append-icon="mdi-magnify"
          v-model="search"
        ></v-text-field>
        <v-switch
          style="margin-left: 10px;"
          dark
          hide-details
          color="yellow"
          label="Mostrar Inativos"
          @click="onSwitchInativesChange()"
        >
        </v-switch>
      </v-col>
      <v-data-table
        dark
        sort-by="name"
        class="elevation-2 mt-4"
        :items="apps"
        :search="search"
        :headers="headers"
        :items-per-page="10"
      >
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-if="loadingTable" class="no-hover text-center">
              <td :colspan="headers.length">
                <v-progress-circular
                  indeterminate
                  class="ma-5"
                  color="yellow"
                  :size="50"
                ></v-progress-circular>
              </td>
            </tr>
            <tr
              class="tr-click"
              v-for="app in items"
              :key="app.id"
              @click="setDataOnForm(app)"
              :style="inativeAppStyle(app)"
            >
              <td class="pr-0">
                <v-avatar size="36">
                  <img
                    v-if="app && app.app_photo && app.app_photo.url"
                    :src="app.app_photo.url"
                  />
                  <img v-else src="@/assets/images/no-photo.jpg" />
                </v-avatar>
              </td>
              <td>{{ app.name }}</td>
              <td>{{ app.description }}</td>
              <td>{{ app.login_url }}</td>
              <td>
                <v-tooltip bottom :disabled="!app.id">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-if="app.id"
                      color="grey darken-1"
                      v-bind="attrs"
                      v-on="on"
                      @click.stop="goToPermissions(app.id)"
                      >mdi-key</v-icon
                    >
                  </template>
                  <span>Ver permissões</span>
                </v-tooltip>
              </td>
            </tr>
            <tr class="no-hover text-center" v-if="!loadingTable && !items.length">
              <td :colspan="headers.length">
                <p class="mt-4">Nenhuma aplicação encontrada</p>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-col>
    <v-btn right absolute bottom fab color="yellow" @click="openCreateDialog()">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-dialog
      dark
      persistent
      v-model="dialog"
      max-width="800px"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-list class="fields-input" three-line subheader>
          <v-col cols="12" class="text-center pt-0">
            <v-avatar size="128" @click="openFile()" class="file-user">
              <img v-if="photo && photo.url" :src="photo.url" :loading="photo" />
              <img :loading="photo" v-else src="@/assets/images/no-photo.jpg" />
              <div class="overlay d-flex justify-center align-center">
                <v-icon>mdi-camera</v-icon>
              </div>
            </v-avatar>
            <v-file-input
              id="inputFile"
              v-model="file"
              style="display: none"
            ></v-file-input>
          </v-col>
          <v-text-field
            v-model="client_id"
            label="Client ID"
            required
            color="yellow"
            :disabled="disableFields"
          ></v-text-field>
          <v-text-field
            color="yellow"
            v-model="name"
            label="Nome"
            required
          ></v-text-field>
          <v-text-field
            color="yellow"
            v-model="desc"
            label="Descrição"
            required
          ></v-text-field>
          <v-text-field
            color="yellow"
            v-model="login_url"
            label="Url de login"
            required
          ></v-text-field>
          <v-text-field
            color="yellow"
            v-model="redirect_uri"
            label="Url de redirecionamento"
            required
          ></v-text-field>
          <v-text-field readonly v-model="color" hide-details class="ma-0 pa-0" solo>
            <template v-slot:append>
              <v-menu
                v-model="menu"
                top
                nudge-bottom="105"
                nudge-left="16"
                :close-on-content-click="false"
              >
                <template v-slot:activator="{ on }">
                  <div :style="swatchStyle" v-on="on" />
                </template>
                <v-card>
                  <v-card-text class="pa-0">
                    <v-color-picker v-model="color" flat />
                  </v-card-text>
                </v-card>
              </v-menu>
            </template>
          </v-text-field>
          <v-switch
            v-model="active_load"
            model="active"
            dark
            hide-details
            color="yellow"
            label="Ativar"
            @click="onActiveChange()"
          ></v-switch>
        </v-list>
        <v-card-actions>
          <v-btn v-if="id" text @click="goToPermissions(id)"> ver permissões </v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="closeForm()"> Fechar </v-btn>
          <v-btn color="yellow" text @click="save()"> Salvar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Cropper da foto -->
    <v-dialog dark persistent width="500" v-model="dialogCropper">
      <v-card>
        <v-card-text class="pa-0">
          <div style="width: 500px; height: 500px; overflow: hidden">
            <cropper
              style="height: 100%; width: 100%"
              :src="img"
              @change="change"
              :auto-zoom="false"
              image-restriction="stencil"
              :stencil-props="{
                previewClass: 'preview',
              }"
              stencil-component="circle-stencil"
            />
          </div>
          <v-btn
            depressed
            class="rounded-0"
            style="width: 50%"
            @click="dialogCropper = false"
            >Cancelar</v-btn
          >
          <v-btn depressed class="rounded-0" style="width: 50%" @click="changeImg()"
            >Salvar</v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script lang="ts">
import { Vue, Component, Watch } from "vue-property-decorator";
import { getApps } from "@/services/apps";
import { changeApp, createApp, updateAppPhoto } from "@/services/apps";
import { postFile, uploadAWS } from "@/services/file";

@Component
export default class Apps extends Vue {
  search: any = "";
  apps: any = [];
  allApps: any = [];
  loadingTable = true;
  loadInatives = false;
  headers = [
    { value: "color", width: "1%" },
    { text: "Nome", value: "name", width: "20%" },
    { text: "Descrição", value: "description" },
    { text: "URL login", value: "login_url", width: "39%" },
    { text: "", value: "actions", width: "fit-content" },
  ];

  // Props do Formulário
  active_load = true
  app_name = "";
  name = "";
  desc = "";
  login_url = "";
  id = "";
  active = true;
  client_id = "";
  redirect_uri = "";
  disableFields = false;
  dialog = false;
  createForm = false;
  photo: any = {
    url: "",
  };
  file: any = null;

  // Color Picker
  color = "#1976D2FF";
  mask = "!#XXXXXXXX";
  menu = false;

  dialogCropper = false;
  tempImg: any = "";
  changeFile: any = false;
  img: any = "";

  async created(): Promise<void> {
    await this.getBackApps();

    await this.getFiltredApps();

    this.loadingTable = false;

    if (Object.keys(this.$route.query).length !== 0) {
      let id: any = atob(this.$route.query.id + "");
      this.setDataOnForm(this.apps.find((a: any) => a.id == id));
    }
  }

  get swatchStyle(): any {
    const { color, menu } = this;
    return {
      backgroundColor: color,
      cursor: "pointer",
      height: "30px",
      width: "30px",
      borderRadius: menu ? "50%" : "4px",
      transition: "border-radius 200ms ease-in-out",
    };
  }

  inativeAppStyle(app: any): any {
    return app.active ? "opacity: 100%;" : "opacity: 50%;"
  }

  @Watch("file")
  onPropertyChanged(): void {
    if (this.changeFile) {
      this.changeFile = false;
      return;
    }
    if (this.file == null) return;
    var reader = new FileReader();
    reader.readAsDataURL(this.file);
    reader.onload = () => {
      if (reader.result) {
        this.img = reader.result;
        this.dialogCropper = true;
        let inputFileHeader: any = document.getElementById("inputFile");
        inputFileHeader.value = "";
      }
    };
  }

  onSwitchInativesChange(): void {
    this.loadInatives = !this.loadInatives
  }

  onActiveChange(): void {
    this.active = !this.active;
  }

  async getBackApps(): Promise<void> {
    await getApps()
      .then((apps: any) => {
        this.allApps = apps.data
      })
      .catch((error: any) => {
        console.error(error);
        if (error.message.includes("403")) this.$router.push({ name: "login" });
        this.$emit("snackbar", {
          message: "Erro ao carregar os aplicativos!",
        });
      });
  }

  @Watch("loadInatives")
  async getFiltredApps(): Promise<void> {
    this.apps = this.loadInatives
      ? this.allApps
      : this.allApps.filter((app: any) => app.active)
  }

  openFile(): void {
    document.getElementById("inputFile")?.click();
  }

  closeForm(): void {
    if (this.$route.fullPath != this.$route.path) this.setQuery();
    this.dialog = false;
    this.name = "";
    this.app_name = "";
    this.desc = "";
    this.login_url = "";
    this.id = "";
    this.client_id = "";
    this.redirect_uri = "";
    this.active = false;
    this.photo = {
      url: "",
    };
    this.file = null;
  }

  openCreateDialog(): void {
    this.dialog = true;
    this.createForm = true;
    this.disableFields = false;
  }

  goToPermissions(appId: string): void {
    this.$router.push({ name: "permissions", query: { searchApp: appId } });
  }


  setDataOnForm(form: any): void {
    this.addfilters(form.id);
    this.createForm = false;
    this.dialog = true;
    this.disableFields = true;
    this.name = form.name;
    this.app_name = form.name;
    this.desc = form.description;
    this.login_url = form.login_url;
    this.client_id = form.client_id;
    this.active_load = form.active;
    this.active = form.active;
    this.color = form.color ? form.color : "#E5EE04FF";
    this.id = form.id;
    this.redirect_uri = form.redirect_uri;
    if (form.app_photo) this.photo = form.app_photo;
  }

  save(): void {
    const updatedApp = {
      name: this.name,
      description: this.desc,
      login_url: this.login_url,
      client_id: this.client_id,
      redirect_uri: this.redirect_uri,
      color: this.color,
      active: this.active,
    };
    this.createForm
      ? createApp(updatedApp)
          .then((res: any) => {
            if (this.file != null) {
              const payloadFile = {
                folders: ["apps", "photo"],
                original_name: this.file.name,
                content_type: this.file.type,
                size: this.file.size,
              };
              postFile(payloadFile)
                .then((fileAWS: any) => {
                  let formData = new FormData();
                  formData.append("Content-Type", fileAWS.data.content_type);
                  formData.append("key", fileAWS.data._storage.fields.key);
                  formData.append(
                    "AWSAccessKeyId",
                    fileAWS.data._storage.fields.AWSAccessKeyId
                  );
                  formData.append("acl", fileAWS.data._storage.fields.acl);
                  formData.append("policy", fileAWS.data._storage.fields.policy);
                  formData.append("signature", fileAWS.data._storage.fields.signature);
                  formData.append("file", this.file);
                  uploadAWS(fileAWS.data._storage.url, formData).then(() => {
                    this.photo.url = fileAWS.data.url;
                    updateAppPhoto(this.id, { app_photo_id: fileAWS.data.id });
                  });
                })
                .catch((err: any) => console.info(err));
            }
            this.dialog = false;
            this.apps.push(updatedApp);
            this.$emit("snackbar", {
              message: "App foi criado!",
            });
          })
          .catch((err: any) => {
            console.info(err);
          })
      : changeApp(this.id, updatedApp)
          .then((res: any) => {
            this.apps.map((app: any) => {
              if (app.id == this.id) {
                app.name = updatedApp.name;
                app.description = updatedApp.description;
                app.login_url = updatedApp.login_url;
                app.redirect_uri = updatedApp.redirect_uri;
                app.active = updatedApp.active;
              }
            });
            if (this.file != null) {
              const payloadFile = {
                folders: ["apps", "photo"],
                original_name: this.file.name,
                content_type: this.file.type,
                size: this.file.size,
              };
              postFile(payloadFile)
                .then((fileAWS: any) => {
                  let formData = new FormData();
                  formData.append("Content-Type", fileAWS.data.content_type);
                  formData.append("key", fileAWS.data._storage.fields.key);
                  formData.append(
                    "AWSAccessKeyId",
                    fileAWS.data._storage.fields.AWSAccessKeyId
                  );
                  formData.append("acl", fileAWS.data._storage.fields.acl);
                  formData.append("policy", fileAWS.data._storage.fields.policy);
                  formData.append("signature", fileAWS.data._storage.fields.signature);
                  formData.append("file", this.file);
                  uploadAWS(fileAWS.data._storage.url, formData).then(() => {
                    this.photo.url = fileAWS.data.url;
                    updateAppPhoto(this.id, { app_photo_id: fileAWS.data.id });
                  });
                })
                .catch((err: any) => console.info(err));
            }
            this.$emit("snackbar", {
              message: "App foi atualizado!",
            });
            console.info(res);
            this.dialog = false;
          })
          .catch((err: any) => {
            console.info(err);
          });
  }

  addfilters(id: any): void {
    if (this.$route.fullPath == this.$route.path) {
      let query: any = {
        id: btoa(id),
      };
      this.setQuery(query);
    }
  }

  setQuery(query: any = {}): void {
    let name: any = this.$route.name;
    this.$router.replace({
      name: name,
      query: query,
    });
  }

  change({ canvas }: any): void {
    this.tempImg = canvas.toDataURL();
  }

  changeImg(): void {
    this.changeFile = true;
    this.photo.url = this.tempImg;
    this.file = this.dataURLtoFile(this.tempImg);
    this.dialogCropper = false;
  }

  dataURLtoFile(dataurl: any): any {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], this.file.name, { type: mime });
  }
}
</script>
<style lang="scss" scoped>
.file-user :hover {
  cursor: pointer;
}
.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: 0.3s ease;
  background-color: rgba(0, 0, 0, 0.3);
}
.overlay:hover {
  opacity: 1;
}
</style>
